export const MESSAGE_TYPE_DICTIONARY = {
  profile: 'seu perfil',
  points: 'seu saldo de pontos'
}
